var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverspeed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 17",
    fill: "#DC3545",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2072 0C7.77162 0.135192 5.4544 1.09473 3.63623 2.721L6.34923 5.434C7.5974 4.99198 8.9603 4.99693 10.2052 5.448L10.2072 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.673 7.194L17.804 2.512C16.0233 1.01127 13.8032 0.129688 11.478 0V6.1C11.9276 6.40591 12.3316 6.77389 12.678 7.193L12.673 7.194Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03118e-05 10.8229V11.4619H2.54104V10.8269C2.54064 9.87284 2.77898 8.93385 3.23432 8.09547C3.68967 7.25709 4.34755 6.54597 5.14804 6.02689L2.74004 3.6189C0.968734 5.59966 -0.00722848 8.16566 4.03118e-05 10.8229V10.8229Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3149 11.4629H21.6839V10.8279C21.6844 9.91735 21.5708 9.0103 21.3459 8.12793L18.3149 11.4629Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8422 11.48C10.2545 11.4808 9.68519 11.6853 9.23132 12.0587C8.77744 12.4321 8.46704 12.9513 8.35299 13.5279C8.23894 14.1045 8.32829 14.7028 8.60581 15.2208C8.88334 15.7389 9.33189 16.1448 9.87506 16.3693C10.4182 16.5938 11.0224 16.6231 11.5848 16.4521C12.1471 16.2812 12.6328 15.9206 12.9591 15.4318C13.2854 14.943 13.4322 14.3561 13.3744 13.7712C13.3166 13.1863 13.0579 12.6396 12.6422 12.224C12.4064 11.987 12.1258 11.7992 11.8168 11.6715C11.5078 11.5438 11.1766 11.4787 10.8422 11.48V11.48Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.982 3.15796L11.231 10.23C12.1023 10.3191 12.9163 10.7059 13.5357 11.3253C14.155 11.9446 14.5419 12.7586 14.631 13.63L21.684 5.86396V3.16396L18.982 3.15796Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverspeed);
export default __webpack_public_path__ + "static/media/overspeed.4c2097a66507cb2e70c76d813fa5d9cb.svg";
export { ForwardRef as ReactComponent };